import React, { createContext, useContext, useEffect, useState } from 'react';
import { SportsbookApi } from '@atlas/core';

const SelectionsContext = createContext();

const createSelectionsProvider = () => {
  const [selections, setSelections] = useState([]);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    SportsbookApi.findSelections({})
      .then(({ selections }) => {
        setSelections(selections);
      })
      .finally(() => {
        setIsLoading(false);
      });
  }, []);

  return {
    selections,
    setSelections,
    isLoading,
  };
};

export const SelectionProvider = ({ children }) => {
  const contextValue = createSelectionsProvider();

  return <SelectionsContext.Provider value={contextValue}>{children}</SelectionsContext.Provider>;
};

export const useSelectionsContext = () => useContext(SelectionsContext);
